import styled from "@emotion/styled";

import { commonColors } from "application/theme";

export const Container = styled("div")`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled("div")`
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  padding: 40px 20px;
  border-radius: 32px;
  background: ${commonColors.white};

  h1 {
    margin-bottom: 20px;
    /* font */
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    margin-bottom: 4px;
    text-align: center;
    color: ${commonColors.grey900};
  }
`;

export const BackgroundContainer = styled("div")`
  position: relative;
  img.background {
    width: 100%;
    height: 113px;
    margin-bottom: 4px;
  }
  img.user {
    top: 27px;
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
    border-radius: calc(60px / 2);
  }
`;

export const Content = styled("div")`
  h5 {
    margin-bottom: 2px;
    /* font */
    font-size: 18px;
    font-weight: 500;
    line-height: 140%;
    text-align: center;
    color: ${commonColors.grey900};
  }
  small {
    display: block;
    margin-bottom: 20px;
    /* font */
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    text-align: center;
    letter-spacing: 0.07px;
    color: ${commonColors.grey500};
  }
  p {
    margin-bottom: 8px;
    /* font */
    font-size: 18px;
    font-weight: 400;
    line-height: 130%;
    text-align: center;
    color: ${commonColors.grey900};
  }
`;

export const DateContainer = styled("div")`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  svg {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 6px;
    /* font */
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    text-align: center;
    letter-spacing: 0.07px;
    color: ${commonColors.grey500};
  }
`;

export const ButtonsSection = styled("div")`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const LoaderContainer = styled("div")`
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
